<template>
    <b-card no-body class="main-layout" :class="showScrollbar || isMenuVisible ? 'main-layout--with-scrollbar' : ''">

        <TheNavbar @change="(visible) => isMenuVisible = visible"/>

        <b-card-body style="line-height: 18px">
            <router-view :show-scrollbar="showScrollbar"/>
        </b-card-body>
    </b-card>
</template>


<script>
import TheNavbar from '@/components/TheNavbar.vue';
import _ from 'lodash';

export default {
    components: {
        TheNavbar
    },
    data() {
        return {
            isMenuVisible: null,
            path: null,
            // Name of the routes to show the scrollbar
            viewsWithScrollbar: [
                'dashboard',
                'site-files',
                'ticket-list',
                'ticket-detail',
                'user-profile',
                'admin-site',
                'admin-site-edit',
                'permissions',
                'edit-permissions',
                'add-permission',
                'emission-library',
                'locations',
                'register',
                'compare'
                // 'users',
                // 'tags',
            ]
        };
    },
    computed: {
        // Returns true if page is supposed to have scrollbar
        showScrollbar() {
            return _.includes(this.viewsWithScrollbar, this.$route.name);
        }
    },
    methods: {
        routeTo(path) {
            this.$router.push(path);
        },
    },
    created() {
        this.$store.state.siteId = this.route.query.site_id
            ? Number(this.route.query.site_id)
            : this.$store.state.siteId;
        this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.year;
        if (this.route.name === 'main') {
            this.routeTo({name: 'dashboard'});
        }
    }
};
</script>


<style lang="scss" scoped>
.card-body {
    background-color: #eff3f6;
}

.tablet {
    .navigation-menu > li > a {
        padding: 20px 16px;
    }
}
@media print {
    .non-printable {
        display: none !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Main.vue